export default {
      id: "search-usage",
      viewBox: "0 0 26 27",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#search",
      toString: function () {
        return this.url;
      }
    }